import script from "./check.attempts.modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./check.attempts.modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__